import { SearchFilters } from "@outschool/gql-frontend-generated";
import { searchPath } from "@outschool/routes";
import { useProductListViewed } from "@outschool/ui-analytics";
import { TrackingProperties } from "@outschool/ui-legacy-component-library";
import { useOnScreen } from "@outschool/ui-utils";
import React, { useEffect, useState } from "react";

import { useParentDashboardFilters } from "../ParentDashboardFilters";
import { useSearchListings } from "../useListingsForCard";
import ListCard from "./ListCard";

const useDelay = (delay: $TSFixMe) => {
  const [delayed, setDelayed] = useState(delay > 0);
  useEffect(() => {
    const timeout = setTimeout(() => setDelayed(false), delay);
    return () => clearTimeout(timeout);
  }, [delay, setDelayed]);
  return delayed;
};

export default function SearchListingsCard({
  id,
  title,
  subtitle,
  url,
  trackingProperties,
  searchFilters,
  loadAfterDelay = 0,
  filter
}: {
  id: string;
  title: string;
  subtitle?: string;
  url?: string;
  trackingProperties: TrackingProperties;
  searchFilters: SearchFilters;
  loadAfterDelay?: number;
  filter?: React.ReactNode;
}) {
  const ref = React.useRef();
  const isOnScreen = useOnScreen(ref.current, false, "2000px 0px");
  const delayed = useDelay(loadAfterDelay);

  const { searchFilters: additionalSearchFilters } =
    useParentDashboardFilters();
  const { loading, listings } = useSearchListings(
    searchFilters,
    additionalSearchFilters,
    /* skip */ delayed && !isOnScreen,
    /* skip */ delayed && !isOnScreen
  );
  const trackProductListViewed = useProductListViewed();
  const defaultUrl = searchPath({
    ...searchFilters,
    ...additionalSearchFilters
  });

  // @ts-ignore TS(2345): Argument of type '{ __typename?: "Listing" | undef... Remove this comment to see the full error message
  trackProductListViewed("parent-dashboard", id, listings);

  return (
    <ListCard
      id={id}
      title={title}
      listings={listings}
      loading={loading}
      trackingProperties={{
        searchFilters: {
          ...searchFilters,
          ...additionalSearchFilters
        },
        ...trackingProperties
      }}
      url={url || defaultUrl}
      subtitle={subtitle}
      filter={filter}
    />
  );
}
